import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    ref: "validationLabel",
    for: $props.elementId,
    class: _normalizeClass({ warn: $data.showWarning })
  }, _toDisplayString($options.getText), 11, _hoisted_1))
}